export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/rep/lesson/resource/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/rep/lesson/resource/get?id=${data.id}`,
                data
            })
        },
        queryAll(data) {
            return http.json({
                url: `/rep/lesson/resource/queryAll`,
                data
            })
        },
        saveInfo(data) {
            return http.json({
                url: `/rep/lesson/resource/save`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/rep/lesson/resource/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/rep/lesson/resource/delete`,
                data
            })
        },


    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/lessonResource.js